import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { useAppSelector } from "src/app-redux/hooks";
import { useStyles } from "./style";
import NoRecordFound from "src/components/NoRecordFound";
import moment from "moment";
import { selectPaymentDetails } from "src/app-redux/commercial/commercialSlice";
import BankTransfer from "src/assets/images/payment_modes/banktransfer.svg";
import Cash from "src/assets/images/payment_modes/cash.svg";
import Easypaisa from "src/assets/images/payment_modes/easypaisa.svg";
import JazzCash from "src/assets/images/payment_modes/jazzcash.svg";

export interface IDrawerHistoryProps {}

export default function DrawerHistory(props: IDrawerHistoryProps) {
  const classes = useStyles();

  // Redux
  const paymentDetailsResponse: any = useAppSelector(selectPaymentDetails);
  return (
    <Grid container direction="row">
      <Grid
        item
        md={1}
        style={{
          borderBottomLeftRadius:
            paymentDetailsResponse &&
            paymentDetailsResponse.paymentHistory &&
            paymentDetailsResponse.paymentHistory?.length > 1
              ? "15px"
              : 0,
          borderLeft:
            paymentDetailsResponse && paymentDetailsResponse.paymentHistory?.length > 1
              ? "1px solid #D5DCE1"
              : "none",
          marginLeft: "10px",
          marginTop: "25px",
        }}
      ></Grid>
      <Grid
        item
        md={10}
        id="main-div"
        className={classes.drawerDetails}
        style={{
          marginLeft: "-48px",
          height: "max-content",
        }}
      >
        {/* History Item  */}
        {paymentDetailsResponse &&
        paymentDetailsResponse.paymentHistory &&
        paymentDetailsResponse.paymentHistory?.length !== 0 ? (
          paymentDetailsResponse &&
          paymentDetailsResponse.paymentHistory.map((item: any, index: any) => (
            <>
              <Grid
                key={index}
                container
                spacing={2}
                className={
                  paymentDetailsResponse &&
                  paymentDetailsResponse.paymentHistory &&
                  paymentDetailsResponse.paymentHistory.length !== 1 &&
                  index == paymentDetailsResponse.paymentHistory.length - 1
                    ? "topContainerTrailLastDiv"
                    : "topContainerTrail"
                }
              >
                <Grid container direction="row" className="itemRowTrail">
                  <Grid md={1}>
                    {(paymentDetailsResponse &&
                      paymentDetailsResponse.paymentHistory.length == 1) ||
                    index != paymentDetailsResponse.paymentHistory.length - 1 ? (
                      <img
                        style={{ width: "100%", marginLeft: "-5px" }}
                        src={
                          item.paymentMethod === "Bank Transfer"
                            ? BankTransfer
                            : item.paymentMethod === "Cash"
                            ? Cash
                            : item.paymentMethod === "Easypaisa"
                            ? Easypaisa
                            : item.paymentMethod === "Jazz Cash"
                            ? JazzCash
                            : ""
                        }
                        alt={item.paymentMethod}
                      />
                    ) : (
                      <div></div>
                    )}
                  </Grid>
                  <Grid md={11}>
                    <Typography className="subHeading">
                      <b>
                        {item.currency ? item.currency : "-"}{" "}
                        {item.amount
                          ? item.amount.toLocaleString(undefined, { maximumFractionDigits: 2 })
                          : "-"}{" "}
                      </b>
                      was paid by{" "}
                      <b>{item.vehicleRegistrationNumber ? item.vehicleRegistrationNumber : "-"}</b>{" "}
                      at <b>{moment(new Date(item.paymentDate)).format("hh:mm A, DD/MM/YYYY ")} </b>
                      through <b>{item.paymentMethod ? item.paymentMethod : "-"}</b> to{" "}
                      <b>{item.createdBy ? item.createdBy : "-"}</b>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ))
        ) : (
          <div style={{ marginTop: "20px" }}>
            <NoRecordFound />
          </div>
        )}
      </Grid>
    </Grid>
  );
}
